<div class="card">
  <div
    class="card-body align-items-center justify-content-between"
    style="gap: 1rem"
  >
    <div class="form-row" *ngIf="!result">
      <div class="form-group col-md-4">
        <label for="inputState">TIPO DE DOCUMENTO</label>
        <select
          id="inputState"
          class="form-control texto"
          [(ngModel)]="doc_selected"
        >
          <option [value]="item.cod_causal" *ngFor="let item of docs">
            {{ item.des }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-8">
        <label for="inputZip">NUMERO DE DOCUMENTO</label>
        <input
          type="text"
          class="form-control texto"
          [(ngModel)]="n_ide"
          id="inputZip"
        />
      </div>
      <button mat-button class="primary" (click)="mostrar_habeas()">
        Consultar
      </button>
    </div>

    <div *ngIf="!cargar; else cargando">
      <form *ngIf="result && mostrar === 'habeas'">
        <div *ngIf="!otpEnviada; else verificarCodigo">
          <div class="card-header pb-1 pt-1">
            <h2>
              Autorización de consulta de tratamiento de datos personales y
              consulta en centrales de riesgo.
            </h2>
          </div>

          <div class="card-body">
            Al ingresar el número celular del cliente, se enviará un mensaje con
            el código donde el cliente autoriza la consulta.
          </div>
          <div class="card-header pb-3 pt-3">
            Este número se utilizará durante todo su proceso de venta y no podrá
            cambiarlo.
            <div class="card-body">
              <mat-form-field appearance="fill" class="col-12 col-md-3">
                <mat-label>Número de celular</mat-label>
                <input matInput type="tel" name="numero" [(ngModel)]="numero" />
              </mat-form-field>
              <div class="card-body pb-2 pt-2">
                <button
                  mat-button
                  class="primary"
                  (click)="funcion_modal_otp(numero)"
                >
                  Enviar
                </button>
                <button
                  mat-flat-button
                  color="warn"
                  (click)="funcion_cliente_no_acepta()"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <ng-template #verificarCodigo>
        <div *ngIf="!codigoEnviado; else validacionOtp">
          <div class="descripcion descripcion2">
            Para continuar ingresa el código que llego al teléfono de tu
            cliente.
          </div>

          <div class="verification">
            <code-input
              (codeChanged)="otp = $event"
              [isCodeHidden]="false"
              [codeLength]="5"
            ></code-input>
          </div>
          <br>
          <button
            mat-button
            class="primary"
            type="button"
            (click)="verificar_otp()"
          >
            Continuar
          </button>
          <button mat-flat-button color="warn" type="button" (click)="noCode()">
            No ha llegado el código
          </button>
        </div>
        <ng-template #validacionOtp>
          <div *ngIf="aprobado; else noAprobado">
            <div class="centrado">
              <img src="" />
              <div class="tituloCargando">
                El código ha sido confirmado exitosamente.
              </div>
              <div class="descripcion descripcion2">
                Hemos confirmado que el código ingresado es válido puedes
                continuar con tu venta a crédito.
              </div>
            </div>
          </div>

          <ng-template class="centrado" #noAprobado>
            <div class="centrado">
              <div class="tituloCargando">
                No se ha podido realizar la confirmación de este código.
              </div>
              <div class="descripcion descripcion2">
                El código ingresado es inválido por favor vuelve a enviar el
                mensaje.
              </div>
              <button mat-button class="primary" (click)="volverEnviarOtp()">
                Volver a enviar código
              </button>
            </div>
          </ng-template>
        </ng-template>
      </ng-template>
    </div>

    <ng-template #cargando>
      <div class="centrado" title="1">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="40px"
          height="40px"
          viewBox="0 0 50 50"
          style="enable-background: new 0 0 50 50"
          xml:space="preserve"
        >
          <path
            fill="#000"
            d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
          >
            <animateTransform
              attributeType="xml"
              attributeName="transform"
              type="rotate"
              from="0 25 25"
              to="360 25 25"
              dur="0.6s"
              repeatCount="indefinite"
            />
          </path>
        </svg>
        <div class="tituloCargando">
          Espere unos momentos mientras
          {{ !otpEnviada ? "enviamos" : "validamos" }} el código...
        </div>
      </div>
    </ng-template>

    <!--Formulario Visor modo E-->

    <form *ngIf="result && mostrar == 'evaluar'">
      
      <h2>
        Ingrese los datos de su cliente.
      </h2>
      
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="inputAddress">NOMBRE</label>
          <input
            type="text"
            class="form-control texto"
            id="primer_nombre"
            name="primer_nombre"
            [(ngModel)]="data.primer_nombre"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="inputAddress2">APELLIDO</label>
          <input
            type="text"
            class="form-control texto"
            id="primer_apellido"
            name="primer_apellido"
            [(ngModel)]="data.primer_apellido"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="inputEmail4">CORREO</label>
          <input
            type="email"
            class="form-control texto"
            id="correo"
            name="correo"
            [(ngModel)]="data.correo"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="inputPassword4">TELEFONO</label>
          <input
            type="number"
            class="form-control texto"
            id="celular"
            name="celular"
            [(ngModel)]="data.celular"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-12">
          <button
            type="submit"
            class="btn btn-primary btn-block"
            (click)="modo_e()"
          >
            Evaluar
          </button>
        </div>
      </div>
    </form>

    <div class="form-row" *ngIf="(data || result) && mostrar === 'detalle'  && aprobado===true">
      <div class="form-group col-md-12">
        <div
          class="alert alert-primary"
          [ngClass]="{ 'alert-danger': result.viable == 'ROJO' }"
          role="alert"
        >
          <h4 class="alert-heading">NOMBRE DEL CLIENTE: {{result.primer_nombre}} {{result.primer_apellido}}</h4>
          <p>CEDULA: {{result.n_ide}}</p>
          <p>CLIENTE: {{ result.viable }}</p>
          <p>CUPO DISPONIBLE: {{ result.cupo }}</p>
          <p>SEGMENTO: {{ result.segmento }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- <div
    class="alert alert-danger"
    role="alert"
    *ngIf="data && data.msn_error != ''"
  >
    {{ data.msn_error }}
  </div>
  <pre>
    {{ data | json }}
  </pre>
  <pre>
    {{ result | json }}
  </pre> -->
</div>
